module.exports = __webpack_public_path__ + "static/media/menash.d4e5dddb.png";